export default function InsurancePanel() {
  return (
    <section className="py-5 bg-white border-top border-bottom">
      <div className="container">
        <h2 className="fw-bold h3 mb-3">Insurance & Payment</h2>
        <div className="row g-4">
          <div className="col-12 col-lg-6">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">We accept</h5>
                <ul className="mb-0">
                  <li>Private pay (cash/card)</li>
                  <li>Insurance & facility billing</li>
                  <li>Medicaid (where eligible)</li>
                </ul>
                <p className="text-secondary small mt-2">Coverage varies by plan and state. We’ll help verify eligibility.</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">Documents on request</h5>
                <ul className="mb-0">
                  <li>Certificate of Insurance</li>
                  <li>Driver training & background checks</li>
                  <li>Vehicle inspection & maintenance logs</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
